import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Phone, Mail, Clock, MapPin, Calendar } from 'lucide-react';

export const BookAppointment = () => {
  const handleCall = () => {
    window.open('tel: +917066901355');
  };

  const handleEmail = () => {
    window.open('mailto:Support@nandedhospitalpune.in');
  };

  return (
    <section id="contact" className="py-24 bg-[hsl(var(--muted))]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <div className="inline-flex items-center space-x-2 bg-[hsl(var(--primary))]/10 px-4 py-2 rounded-full">
            <Calendar className="w-5 h-5 text-[hsl(var(--primary))]" />
            <span className="text-sm font-semibold text-[hsl(var(--primary))]">
              Get In Touch
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-[hsl(var(--foreground))]">
            Contact Us for
            <span className="block mt-2 text-gradient">Appointments</span>
          </h2>
          <p className="text-lg text-[hsl(var(--muted-foreground))] max-w-2xl mx-auto">
            Reach out to us anytime. We're here to help you with all your healthcare needs.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Emergency Hotline */}
          <Card className="border-2 border-[hsl(var(--primary))]/20 hover:shadow-[var(--shadow-xl)] transition-all duration-300 hover:-translate-y-2">
            <CardHeader>
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[hsl(var(--primary))] to-[hsl(var(--secondary))] flex items-center justify-center shadow-[var(--shadow-md)] mb-4 mx-auto">
                <Phone className="w-8 h-8 text-white" />
              </div>
              <CardTitle className="text-xl text-center">Emergency Hotline</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-center">
              <p className="text-[hsl(var(--muted-foreground))]">
                24/7 emergency medical assistance
              </p>
              <Button
                variant="premium"
                className="w-full font-semibold"
                onClick={handleCall}
              >
                <Phone className="w-5 h-5 mr-2" />
                +917066901355
              </Button>
            </CardContent>
          </Card>

          {/* Email Contact */}
          <Card className="border-2 border-[hsl(var(--secondary))]/20 hover:shadow-[var(--shadow-xl)] transition-all duration-300 hover:-translate-y-2">
            <CardHeader>
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[hsl(var(--secondary))] to-[hsl(var(--accent))] flex items-center justify-center shadow-[var(--shadow-md)] mb-4 mx-auto">
                <Mail className="w-8 h-8 text-white" />
              </div>
              <CardTitle className="text-xl text-center">Messege Us</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4 text-center">
              <p className="text-[hsl(var(--muted-foreground))]">
                Get in touch for appointments
              </p>
              <Button
                variant="outline"
                className="w-full font-semibold"
                onClick={handleEmail}
              >
                <Mail className="w-5 h-5 mr-2" />
                Email Us
              </Button>
              <Button
                variant="outline"
                className="w-full font-semibold"
                onClick={handleEmail}
              >
                <Mail className="w-5 h-5 mr-2" />
                Watsaap Us : +917249023462
              </Button>

            </CardContent>
          </Card>

          {/* Working Hours */}
          <Card className="border-2 border-[hsl(var(--accent))]/20 hover:shadow-[var(--shadow-xl)] transition-all duration-300 hover:-translate-y-2">
            <CardHeader>
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[hsl(var(--accent))] to-[hsl(var(--accent-warm))] flex items-center justify-center shadow-[var(--shadow-md)] mb-4 mx-auto">
                <Clock className="w-8 h-8 text-white" />
              </div>
              <CardTitle className="text-xl text-center">Working Hours</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3 text-center">
              <div>
                <p className="font-semibold text-[hsl(var(--foreground))]">Emergency</p>
                <p className="text-sm text-[hsl(var(--muted-foreground))]">24/7 Available</p>
              </div>
              <div className="pt-2 border-t border-[hsl(var(--border))]">
                <p className="font-semibold text-[hsl(var(--foreground))]">OPD</p>
                <p className="text-sm text-[hsl(var(--muted-foreground))]">Mon-Sat: 8AM - 8PM</p>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Address Section */}
        <div className="mt-12">
          <Card className="max-w-3xl mx-auto hover:shadow-[var(--shadow-lg)] transition-all duration-300">
            <CardContent className="pt-8">
              <div className="flex flex-col md:flex-row items-center md:items-start space-y-4 md:space-y-0 md:space-x-6">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-[hsl(var(--primary))] to-[hsl(var(--accent-warm))] flex items-center justify-center shadow-[var(--shadow-md)] flex-shrink-0">
                  <MapPin className="w-8 h-8 text-white" />
                </div>
                <div className="text-center md:text-left flex-1">
                  <a href="https://maps.app.goo.gl/6idruHNRKPYp8Em69?g_st=aw" target="_blank" rel="noopener noreferrer">
                    <h3 className="text-xl font-bold text-[hsl(var(--foreground))] mb-2">Visit Us</h3>
                    <p className="text-[hsl(var(--muted-foreground))] leading-relaxed">
                      Nanded Hospital, Nirmala Heights, Near Tamilnad Mercantile Bank, Nandedgaon, Pune, Maharashtra 411068
                    </p>
                  </a>
                  <p className="text-sm text-[hsl(var(--muted-foreground))] mt-2">
                    Free parking available for patients and visitors
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};